<template>
    <nav class="menu" v-if="desktopSideBar">
        <profile :profileModal="profileModal"
        :walletId="connectedAccount"
        @disconnect='disconnect'
        @profileModal="closeProfileModal"></profile>
        <transition-group name="fade" tag="ul">
            <li key="1" @click="closeSideBar()" class="side-bar-item" style="margin-top:50px">
                <router-link  :to="{name: 'whitepaper'}">Whitepaper</router-link>
            </li>
            <li key="2" @click="closeSideBar()" class="side-bar-item mt-4">
                <router-link  :to="{name: 'gamedata'}">Game Data</router-link>
            </li>
            <li class="side-bar-item outsider-items d-flex justify-content-center" key="3">
                <a href="https://twitter.com" class="mx-3" target="_blank">
                    <img src="../assets/images/opensea.webp" alt="">
                </a>
                <a href="https://discord.gg/eggsgame" target="_blank">
                    <img src="../assets/images/discord.webp" alt="">
                </a>
                <a href="https://twitter.com/eggsgamenft" class="mx-3" target="_blank">
                    <img src="../assets/images/twtr.webp" alt="">
                </a>
            </li>
        </transition-group>
    </nav>
</template>
<script>
import Profile from './Profile.vue'
export default {
    components: { Profile },
    name:'mobile-sidebar',
    props:{
        desktopSideBar:{
            default: false,
            type: Boolean
        },
        connectedAccount: {
            default: null,
            type: String
        },
        connected:{
            default: false,
            type: Boolean
        }
    },
    data(){
        return{
            profileModal:false
        }
    },
    methods:{
        closeSideBar(){
            this.$emit('openDesktopSidebar' , false)
        },
        connect(){
            this.closeSideBar()
            this.$emit('connect' , true)
        },
        disconnect(){
            this.closeSideBar()
            this.$emit('disconnect' , true)
        },
        closeProfileModal(value){
            this.profileModal = value
        },
    }
}
</script>
<style scoped>
.menu transition-group {
    list-style-type: none;
}
.menu ul{
    padding: 0;
}
.side-bar-item a {
  font-weight: normal;
  color: #fff;
  text-decoration: none;
}
.side-bar-item a.router-link-exact-active {
  color: #ffe371;
  text-decoration: none;
}
.menu{
    left: 0;
    top: 87px;
    position: fixed;
    z-index: 5;
    text-align: center;
    width: 268px;
    height: 100%;
    background: rgba(10, 15, 30, 0.88);
    animation: left-to-right 0.2s ease-in;
}
.outsider-items{
    position: fixed;
    bottom: 65px;
    width: 268px;
}
.connect-wallet{
    background: none;
    border: 3px solid white;
    border-radius: 15px;
    font-size: 20px;
    color: white;
    margin: 25px 30px 20px 0;
}
@keyframes left-to-right {
    from {
        left:calc(110px - 100%);
        transition: ease-in .01s;
    }
    to{
        left:0
    }
}
.side-bar-item{
    list-style-type: none;
    color: white;
    font-size: 35px;
    margin-top:0px
}
@media (max-width: 368px) {
    .side-bar-item{
        font-size: 25px
    }
    .img-screen-change{
        width: 150px;
    }
    .connect-wallet{
        font-size: 17px;
    }
}
</style>